import ajax from '../../utils/ajax';
import SyosEvents from '../utils/SyosEvents';
import SyosAjaxError from '../errors/SyosAjaxError';
import { makeCacheKey, getCachedData, cacheData } from './SyosApiCache';

async function invoke(
  syosController,
  endpoint,
  requestData = null,
  method = 'GET',
  cacheable = true,
  dispatchEventWhenComplete = true,
) {
  const options = {
    url: `/api/syos/${endpoint}`,
    data: requestData,
    type: method,
    timeout: 30000,
    contentType: 'application/json',
    dataType: 'json',
  };

  const useCache = cacheable && false; // For development only!

  syosController.emit(SyosEvents.API_REQUEST_STARTED);

  let cacheKey = null;

  if (useCache) {
    cacheKey = makeCacheKey(endpoint, requestData);
    const cachedData = getCachedData(cacheKey);
    if (cachedData) {
      if (dispatchEventWhenComplete) {
        syosController.emit(SyosEvents.API_REQUEST_COMPLETED);
      }
      return cachedData;
    }
  }

  return new Promise((resolve) => {
    const ajaxMethod = method === 'POST'
      ? ajax.post
      : ajax.get;

    ajaxMethod(options.url, options.data)
      .then((data) => {
        if (useCache) {
          cacheData(cacheKey, data);
        }
        if (dispatchEventWhenComplete) {
          syosController.emit(SyosEvents.API_REQUEST_COMPLETED, { data });
        }

        resolve(data);
      })
      .catch((jqXHR) => {
        const error = new SyosAjaxError(options, jqXHR, '', jqXHR.status);

        syosController.emit(SyosEvents.API_REQUEST_ERROR, { error });

        throw error;
      });
  });
}

export {
  invoke,
};
